// eslint-disable-next-line
import {
  handleChangeActionType,
  handleChangeToInitStateActionType,
} from "../../actions/handleChangeAction";

const INNSYN_ILEGGELSER_FILTER_FORM = "INNSYN_ILEGGELSER_FILTER_FORM";

export const INITIAL_STATE = {
  ileggelsesnummer: "",
  fraDato: "",
  fraTid: "",
  tilDato: "",
  tilTid: "",
  kjennemerke: "",
  gatenavn: "",
  gatenummer: "",
  overtredelse: "",
  leveringstypeId: "",

  validationError: {},
};

export default function SkiftloggFilerFormReducer(
  state = {
    ...INITIAL_STATE,
    validationError: { ...INITIAL_STATE.validationError },
  },
  action,
) {
  switch (action.type) {
    case handleChangeActionType(INNSYN_ILEGGELSER_FILTER_FORM):
      return { ...state, [action.variableName]: action.payload };
    case handleChangeToInitStateActionType(INNSYN_ILEGGELSER_FILTER_FORM):
      return {
        ...INITIAL_STATE,
        validationError: { ...INITIAL_STATE.validationError },
      };
    default:
      return state;
  }
}
